import React from 'react';
import { FlattenSimpleInterpolation } from 'styled-components';
import { ICalloutProps } from '../callout';
import { IBaseComponentProps } from '../types';

export type PopupEvent = 'showPopup' | 'removePopup';

export interface IPopupProps extends IBaseComponentProps<HTMLDivElement>, Pick<ICalloutProps, 'useFullHeight' | 'useFullWidth'> {
    children?: React.ReactNode;
    /**
     * Class name of the popup
     */
    className?: string;
    /**
     * @deprecated since version 1.1.2.
     * @summary
     * Popup component can now be rendered using imperative API "showPopup".
     * This property would be removed in next major release.
     * Please refer to the documentation on how to render Popup using "showPopup" API.
     * @description
     * Should component be hidden
     */
    hidden?: boolean;
    /**
     * Id for the component
     */
    id?: string;
    /**
     * Should close button be hidden
     */
    hideCloseButton?: boolean;
    /**
     * is Show Modal enabled
     */
    showModal?: boolean;
    /**
     *  Title of the popup
     */
    title?: string;
    /**
     * Title alignment of the popup
     */
    titleAlignment?: 'left' | 'center' | 'right';
    /**
     * Footer alignment of the popup
     */
    footerAlignment?: 'left' | 'center' | 'right';
    /**
     * is Popup moveable
     */
    moveable?: boolean;
    /**
    * On Dismiss handler
    */
    onDismiss?(): void;
    /**
     * Inject custom content handler
     */
    onInjectCustomContent?(content: React.ReactNode): React.ReactNode;
    /**
     * On render content handler
     */
    onRenderContent?(): React.ReactNode;
    /**
     * On render footer handler
     */
    onRenderFooter?(): React.ReactNode;
    /**
     * on render title handler
     */
    onRenderTitle?(): React.ReactNode;
}

export interface IWithPopupProps extends Omit<IPopupProps, 'children' | 'onDismiss'> {
    children: React.ReactNode;
    eventManager?: IPopupEventManager;
    onDismiss?(id?: React.Key): void;
}

export type PopupConfig = Omit<IPopupProps, 'onDismiss'> & {
    onDismiss?: (id?: string) => void;
    cssStyles?: FlattenSimpleInterpolation;
};

export interface IPopupEventManager {
    showPopup(config: PopupConfig): void;
    removePopup(id: string): void;
    subscribe(eventName: PopupEvent, handler: Function): void;
    unsubscribe(eventName: PopupEvent, handler: Function): void;
}

export interface IPopupQueueItem extends PopupConfig { }
